import { useIntl } from "@/infra/locale";
import { getAssetFromCloudfront, Text } from "@akina/presentation";

export function PhysiotherapistCard() {
  const { formatMessage } = useIntl();

  const name = formatMessage({ id: "checkoutPage.resultStep.physiotherapistCard.name" });
  const clinic = formatMessage({ id: "checkoutPage.resultStep.physiotherapistCard.clinic" });
  const bio = formatMessage({ id: "checkoutPage.resultStep.physiotherapistCard.bio" });

  return (
    <div className="flex h-full w-full flex-col items-center gap-4 rounded-2xl border-2 border-gray-800/10 bg-white p-4 md:p-6 lg:w-106.75">
      <div className="size-48.5 overflow-hidden rounded-full">
        <img src={getAssetFromCloudfront("fabienne")} alt={name} className="h-full w-full object-cover" />
      </div>
      <div className="flex w-full flex-col gap-4">
        <div className="flex flex-col">
          <Text size="xl" fontWeight="font-extrabold" color="text-gray-800" className="leading-8">
            {name}
          </Text>
          <Text size="sm" className="leading-6" color="text-gray-800/70">
            {clinic}
          </Text>
        </div>
        <Text color="text-gray-800/70">{bio}</Text>
      </div>
    </div>
  );
}
